import React, { useEffect } from "react"
import { View } from "react-native"
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated"
import ActiveTabIndicator from "./ActiveTabIndicator"
import Badge from "./Badge"
import { Tiny } from "../standard/BFText"
import { cn } from "@/components/util/cn"
import type IconProps from "phosphor-react-native"
import { BFColors } from "@/constants/Colors"

interface CustomTabIconProps {
  Icon: React.FC<IconProps.IconProps>
  label: string
  focused: boolean
  defaultScale?: number
  badge?: number | null
}

const CustomTabIcon: React.FC<CustomTabIconProps> = ({
  Icon,
  label,
  focused,
  defaultScale = 1,
  badge,
}) => {
  const scale = useSharedValue(defaultScale)

  useEffect(() => {
    if (focused) {
      scale.value = withTiming(defaultScale - 0.1, { duration: 140 }, () => {
        scale.value = withTiming(defaultScale, { duration: 60 })
      })
    }
  }, [focused, defaultScale])

  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [{ scale: scale.value }],
    }
  })

  return (
    <View className="flex items-center justify-center flex-1">
      <Animated.View style={animatedStyle}>
        <Icon
          color={focused ? BFColors.calmBlue : BFColors.midnightBlue}
          size={28}
          weight={focused ? "duotone" : "regular"}
        />
      </Animated.View>
      <Tiny className={cn(focused ? "text-calm-blue" : "text-midnight-blue")}>
        {label}
      </Tiny>
      <ActiveTabIndicator label={label} isActive={focused} />
      {!!badge && (
        <View className="absolute right-[-6px] top-0">
          <Badge badge={badge} />
        </View>
      )}
    </View>
  )
}

export default CustomTabIcon
